if (!customElements.get('promo-code-badge')) {
  class PromoCodeBadge extends HTMLElement {
    static get observedAttributes() {
      return ['data-price', 'data-tags'];
    }

    connectedCallback() {
      this.classList.add('badge', 'promo-code-badge');
      this.bindPriceChange();
      this.render();
    }

    disconnectedCallback() {
      this.mainElement?.removeEventListener('priceChange', this.onPriceChange);
      this.onPriceChange = null;
    }

    bindPriceChange() {
      this.mainElement = this.closest('.product-main-element');
      if (!this.mainElement || this.onPriceChange) return;
      this.onPriceChange = (event) => {
        if (event.detail && Number.isFinite(event.detail.price)) this.update({ price: event.detail.price });
      };
      this.mainElement.addEventListener('priceChange', this.onPriceChange);
    }

    attributeChangedCallback() {
      if (this.isConnected) this.render();
    }

    update({ price, tags } = {}) {
      if (price !== undefined) this.dataset.price = price;
      if (tags !== undefined) this.dataset.tags = Array.isArray(tags) ? JSON.stringify(tags) : tags;
    }

    get config() {
      return window.promoCodeBadge || null;
    }

    parseTags(rawTags) {
      if (!rawTags) return [];
      let tags = [];
      try {
        const parsed = JSON.parse(rawTags);
        tags = Array.isArray(parsed) ? parsed : [parsed];
      } catch (error) {
        tags = rawTags.replace(/^\[|\]$/g, '').split(',');
      }
      return tags.map((tag) => String(tag).trim().toLowerCase()).filter(Boolean);
    }

    parseFormattedPrice(text) {
      const digits = (text || '').replace(/[^\d.,]/g, '');
      if (!digits) return NaN;
      const lastSeparator = Math.max(digits.lastIndexOf('.'), digits.lastIndexOf(','));
      const hasDecimals = lastSeparator > -1 && digits.length - lastSeparator - 1 === 2;
      const integerPart = (hasDecimals ? digits.slice(0, lastSeparator) : digits).replace(/[.,]/g, '');
      const decimalPart = hasDecimals ? digits.slice(lastSeparator + 1) : '00';
      return parseInt(integerPart + decimalPart, 10);
    }

    getPriceInCents() {
      if (this.dataset.price !== undefined && this.dataset.price !== '') {
        let cents = parseFloat(this.dataset.price);
        if (this.hasAttribute('data-convert-currency') && window.Shopify?.currency) {
          cents = $s.toCartCurrency(cents);
        }
        return cents;
      }
      if (this.dataset.priceSource && this.parentNode) {
        const sourceElement = this.parentNode.querySelector(this.dataset.priceSource);
        return this.parseFormattedPrice(sourceElement?.textContent);
      }
      return NaN;
    }

    isEligible(tags) {
      const config = this.config;
      if (tags.some((tag) => config.excludeTags.includes(tag))) return false;
      if (config.eligibility === 'tags') {
        return tags.some((tag) => config.includeTags.includes(tag));
      }
      return true;
    }

    escapeHtml(value) {
      const element = document.createElement('span');
      element.textContent = value;
      return element.innerHTML;
    }

    hide() {
      this.hidden = true;
      this.innerHTML = '';
    }

    render() {
      const config = this.config;
      if (!config || !config.percent) return this.hide();

      const tags = this.parseTags(this.dataset.tags);
      if (!this.isEligible(tags)) return this.hide();

      const priceInCents = this.getPriceInCents();
      if (!Number.isFinite(priceInCents) || priceInCents <= 0) return this.hide();

      const discountedCents = Math.round(priceInCents * (1 - config.percent / 100));
      const formattedPrice = $s.formatMoney(discountedCents);

      const connector = config.connector || 'WITH CODE';
      this.innerHTML = `<strong class="promo-code-badge-price">${this.escapeHtml(formattedPrice)}</strong> <span class="promo-code-badge-connector">${this.escapeHtml(connector)}</span> <span class="promo-code-badge-code">${this.escapeHtml(config.code)}</span>`;
      this.hidden = false;
    }
  }
  customElements.define('promo-code-badge', PromoCodeBadge);
}
